/**
 * Collections API call, maps to the Django endpoint in api/urls.py.
 */
import api from './client';

/** Returns { collection } — a single collection and its products by id. */
export const fetchProduct = (id) => api.get(`/api/products/${id}/`);